import React, { Component } from 'react';

import {Row, Column} from '../../global/grid/grid';
import Image from '../../global/media/Image';
import StatCircle from '../StatCircle/StatCircle';

import { CarouselHolder, CopyHolder, IncrementButton, DecrementButton, ColorBlock, Copy, DataCounter } from './styled-components';

class Carousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            slideIndex: 0,
            numberOfSlides: this.props.data.images.length,
            positioningValue: 0,
        }
        this.incrementSlides = this.incrementSlides.bind(this);
        this.decrementSlides = this.decrementSlides.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.setVanishingPoint = this.setVanishingPoint.bind(this);
    }
    componentDidMount() {
        document.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.setVanishingPoint);
        setTimeout(() => {
          this.setVanishingPoint();
        }, 100);
    }
    componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.setVanishingPoint);
    }
    handleScroll(e) {
        this.latestKnownScrollY = window.scrollY ? window.scrollY : window.pageYOffset;
        this.requestTick();
    }
    requestTick() {
        if(!this.ticking) {
            requestAnimationFrame(this.update.bind(this));
        }
        this.ticking = true;
    }
    setVanishingPoint() {
        const scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;
        const carouselTop = this.carouselHolder.getBoundingClientRect().top;
        const carouselHeight = this.carouselHolder.getBoundingClientRect().height;
        this.vanishingPoint = scrollTop + carouselTop + (carouselHeight / 2);
    }
    update() {
        this.ticking = false;
        const posValCalc = 1 - (window.innerHeight - (this.vanishingPoint - this.latestKnownScrollY)) / window.innerHeight;
        let positioningValue = 0;
        if(posValCalc < 1 && posValCalc > 0) {
          positioningValue = Math.round((1 - posValCalc) * 100) / 100;
        } else if(posValCalc < 0) {
          positioningValue = 1;
        } else {
          positioningValue = 0;
        }
        if(positioningValue !== this.state.positioningValue) {
            this.setState(
                {
                    positioningValue: positioningValue,
                }
            );
        }
    }
    incrementSlides() {
        const currentSlide = this.state.slideIndex;
        const numberOfSlides = this.state.numberOfSlides - 1;
        if( currentSlide !== numberOfSlides ) {
            this.setState({
                slideIndex: currentSlide + 1,
            });
        } else {
            this.setState({
                slideIndex: 0,
            });
        }
    }
    decrementSlides() {
        const currentSlide = this.state.slideIndex;
        const numberOfSlides = this.state.numberOfSlides - 1;
        if( currentSlide !== 0 ) {
            this.setState({
                slideIndex: currentSlide - 1,
            });
        } else {
            this.setState({
                slideIndex: numberOfSlides,
            });
        }
    }
    buildSlides(images, imageDictionary, slideIndex) {
        const slides = images.map( (imageKey, index) => {
            return (
                <div key={index} style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    transition: 'opacity 0.3s ease-in-out',
                    opacity: slideIndex === index ? '1' : '0'
                }}
                >
                    <Image aspectHeight={4} aspectWidth={5} sizes={imageDictionary[imageKey].sizes} />
                </div>
            )
        } );
        return slides;
    }
    render() {
        const { data, imageDictionary } = this.props;
        if( data.direction === 'left' ) {
            return (
                <div ref={(div) => this.carouselHolder = div}>
                    <Row cblockPaddingTop>
                        <CarouselHolder cw={5} offset={1}>
                            <div style={{width: '100%', position: 'relative', background: 'white'}}>
                                <DataCounter direction={data.direction}>
                                    <StatCircle data={data.datapoint} imageDictionary={imageDictionary} />
                                </DataCounter>
                                <div style={{paddingTop: 'calc((4/5) * 100%)', width: '100%'}}></div>
                                { this.buildSlides(data.images, imageDictionary, this.state.slideIndex) }
                                { this.state.numberOfSlides > 0 &&
                                    <div>
                                        <IncrementButton onClick={ this.incrementSlides } color={data.color}>
                                            <div></div>
                                        </IncrementButton>
                                        <DecrementButton onClick={ this.decrementSlides } color={data.color}>
                                            <div></div>
                                        </DecrementButton>
                                    </div>
                                }
                                <ColorBlock color={data.color} direction={data.direction}>
                                    <div className="stripes"></div>
                                </ColorBlock>
                            </div>                        
                        </CarouselHolder>
                        <CopyHolder cw={4} offset={1}>
                            <div style={{width: '100%', position: 'relative', height: '100%'}}>
                                <Copy color={data.color}>
                                    <div className="city">{data.city}</div>
                                    <div className="state">{data.state}</div>
                                    <div className="initialsHolder">
                                    <span style={{transform: `translate3d(0, ${-30 + (30 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${-20 + (20 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[0]}</span>
                                    <span style={{transform: `translate3d(0, ${120 + (-120 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${15 + (-15 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[1]}</span>
                                    </div>
                                </Copy>
                            </div>
                        </CopyHolder>
                    </Row>
                </div>
            )
        } else {
            return (
                <div ref={(div) => this.carouselHolder = div}>
                    <Row cblockPaddingTop>                        
                        <CopyHolder cw={4} offset={1}>
                            <div style={{width: '100%', position: 'relative', height: '100%'}}>
                                <Copy color={data.color}>
                                    <div className="city">{data.city}</div>
                                    <div className="state">{data.state}</div>
                                    <div className="initialsHolder">
                                    <span style={{transform: `translate3d(0, ${-30 + (30 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${-20 + (20 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[0]}</span>
                                    <span style={{transform: `translate3d(0, ${120 + (-120 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${15 + (-15 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[1]}</span>
                                    </div>
                                </Copy>
                            </div>
                        </CopyHolder>
                        <CarouselHolder cw={5} offset={1}>
                            <div style={{width: '100%', position: 'relative', background: 'white'}}>
                                <DataCounter direction={data.direction}>
                                    <StatCircle data={data.datapoint} imageDictionary={imageDictionary} />
                                </DataCounter>
                                <div style={{paddingTop: 'calc((4/5) * 100%)', width: '100%'}}></div>
                                { this.buildSlides(data.images, imageDictionary, this.state.slideIndex) }
                                { this.state.numberOfSlides > 0 &&
                                    <div>
                                        <IncrementButton onClick={ this.incrementSlides } color={data.color}>
                                            <div></div>
                                        </IncrementButton>
                                        <DecrementButton onClick={ this.decrementSlides } color={data.color}>
                                            <div></div>
                                        </DecrementButton>
                                    </div>
                                }
                                <ColorBlock color={data.color} direction={data.direction}>
                                    <div className="stripes"></div>
                                </ColorBlock>
                            </div>                        
                        </CarouselHolder>
                    </Row>
                </div>
            )
        }
    }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/modules/Carousel/Carousel.js